import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NotificationService } from '../../../../../core/services/notification/notification.service';
import { NotificationContentModel } from '../../../../../core/models/notification/notification-content.model';
import { TranslationModel } from '../../../../../core/models/notification/notification-content-list.model';
import { FullscreenOverlayComponent } from '../../../../components/fullscreen-overlay/fullscreen-overlay.component';
import { ToastService } from '../../../../../core/services/toast.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-system-notification',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FullscreenOverlayComponent,
    TranslateModule,
  ],
  templateUrl: './edit-system-notification.component.html',
  styleUrl: './edit-system-notification.component.scss',
})
export class EditSystemNotificationComponent {
  notificationForm: FormGroup;
  notificationId: string = '';
  notificationContent: NotificationContentModel = {
    id: '',
    notificationType: 0,
    translations: [
      {
        translationId: '',
        subject: '',
        body: '',
        languageCode: '',
        notificationTemplateId: '',
      },
    ],
  };
  notificationContentEn: TranslationModel | any = {
    translationId: '',
    subject: '',
    body: '',
    languageCode: '',
    notificationTemplateId: '',
  };
  notificationContentNl: TranslationModel | any = {
    translationId: '',
    subject: '',
    body: '',
    languageCode: '',
    notificationTemplateId: '',
  };
  isOverlayLoading: boolean = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private notificationService: NotificationService,
    private toastService: ToastService,
    private translate: TranslateService
  ) {
    this.notificationForm = this.fb.group({
      subjectEn: ['', [Validators.required]],
      bodyEn: ['', [Validators.required]],
      subjectNl: ['', [Validators.required]],
      bodyNl: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.notificationId = this.route.snapshot.paramMap.get('id')!;
    this.notificationContent = history.state.notification;
    this.notificationContentEn = this.notificationContent.translations.find(
      (item: any) => item.languageCode === 'en'
    );
    this.notificationContentNl = this.notificationContent.translations.find(
      (item: any) => item.languageCode === 'nl'
    );
    this.notificationForm.patchValue({
      subjectEn: this.notificationContentEn.subject,
      bodyEn: this.notificationContentEn.body,
      subjectNl: this.notificationContentNl.subject,
      bodyNl: this.notificationContentNl.body,
    });
  }

  saveNotification(e: Event) {
    e.preventDefault();

    if (this.notificationId) {
      // Edit notification
      if (this.notificationForm.valid) {
        const formData = {
          id: this.notificationId,
          translations: [
            {
              translationId: this.notificationContentEn.translationId,
              languageCode: this.notificationContentEn.languageCode,
              subject: this.notificationForm.value.subjectEn,
              body: this.notificationForm.value.bodyEn,
            },
            {
              translationId: this.notificationContentNl.translationId,
              languageCode: this.notificationContentNl.languageCode,
              subject: this.notificationForm.value.subjectNl,
              body: this.notificationForm.value.bodyNl,
            },
          ],
        };

        this.notificationService
          .editNotificationTemplate(this.notificationId, formData)
          .subscribe({
            next: () => {
              this.isOverlayLoading = true;
              this.toastService.showToast(
                this.translate.instant('notificationEditedSuccessfully'),
                'success'
              );

              setTimeout(() => {
                this.router.navigate(['/notification-contents/system']);
              }, 2000);
            },
          });
      } else {
        this.toastService.showToast(
          this.translate.instant(
            'allFieldsAreRequiredAndMustBeFilledWithValidValues'
          ),
          'warning'
        );
        this.notificationForm.markAllAsTouched();
      }
    }
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.notificationForm.get(controlName);
    return control ? control.invalid && control.touched : false;
  }
}
